<button
  type="button"
  class="color-picker-swatch"
  [style.backgroundColor]="displayHex"
  [attr.aria-label]="ariaLabel"
  [matTooltip]="ariaLabel"
  matTooltipPosition="above"
  matTooltipClass="design-3d-tooltip"
  #colorPopover="bs-popover"
  [popover]="colorPickerPanel"
  placement="bottom"
  container="body"
  containerClass="color-picker-popover"
  triggers="click"
  [outsideClick]="true"
></button>

<ng-template #colorPickerPanel>
  <div class="color-picker-panel">
    <div class="color-picker-tabs">
      <button type="button" [class.active]="mode === 'cmyk'" (click)="setMode('cmyk')">CMYK</button>
      <button type="button" [class.active]="mode === 'rgb'" (click)="setMode('rgb')">RGB</button>
      <button type="button" [class.active]="mode === 'hex'" (click)="setMode('hex')">Hex</button>
      @if (eyeDropperSupported && mode !== "hex") {
        <button
          type="button"
          class="color-picker-eyedropper"
          aria-label="Pick color from screen"
          matTooltip="Pick color from screen"
          matTooltipPosition="above"
          matTooltipClass="design-3d-tooltip"
          (click)="openEyeDropper()"
        >
          <svg viewBox="0 0 512 512" width="12" height="12" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M341.6 29.2L240.1 130.8l-9.4-9.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l160 160c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-9.4-9.4L482.8 170.4c39-39 39-102.2 0-141.1s-102.2-39-141.1 0zM55.4 323.3c-15 15-23.4 35.4-23.4 56.6l0 42.4L5.4 462.2c-8.5 12.7-6.8 29.6 4 40.4s27.7 12.5 40.4 4L89.7 480l42.4 0c21.2 0 41.6-8.4 56.6-23.4L309.4 335.9l-45.3-45.3L143.4 411.3c-3 3-7.1 4.7-11.3 4.7L96 416l0-36.1c0-4.2 1.7-8.3 4.7-11.3L221.4 247.9l-45.3-45.3L55.4 323.3z"
            />
          </svg>
        </button>
      }
    </div>

    @if (mode === "cmyk") {
      <div class="color-picker-sliders">
        <div class="color-picker-slider-row">
          <span
            class="color-picker-slider-label"
            [matTooltip]="'Cyan'"
            matTooltipPosition="above"
            matTooltipClass="design-3d-tooltip"
            >C</span
          >
          <input
            type="range"
            min="0"
            max="100"
            [ngModel]="displayCmyk.c"
            (ngModelChange)="onCmykChannelChange('c', $event)"
          />
          <input
            type="number"
            class="color-picker-slider-number"
            min="0"
            max="100"
            [ngModel]="displayCmyk.c"
            (ngModelChange)="onCmykChannelChange('c', $event)"
          />
          <span class="color-picker-slider-unit">%</span>
        </div>
        <div class="color-picker-slider-row">
          <span
            class="color-picker-slider-label"
            [matTooltip]="'Magenta'"
            matTooltipPosition="above"
            matTooltipClass="design-3d-tooltip"
            >M</span
          >
          <input
            type="range"
            min="0"
            max="100"
            [ngModel]="displayCmyk.m"
            (ngModelChange)="onCmykChannelChange('m', $event)"
          />
          <input
            type="number"
            class="color-picker-slider-number"
            min="0"
            max="100"
            [ngModel]="displayCmyk.m"
            (ngModelChange)="onCmykChannelChange('m', $event)"
          />
          <span class="color-picker-slider-unit">%</span>
        </div>
        <div class="color-picker-slider-row">
          <span
            class="color-picker-slider-label"
            [matTooltip]="'Yellow'"
            matTooltipPosition="above"
            matTooltipClass="design-3d-tooltip"
            >Y</span
          >
          <input
            type="range"
            min="0"
            max="100"
            [ngModel]="displayCmyk.y"
            (ngModelChange)="onCmykChannelChange('y', $event)"
          />
          <input
            type="number"
            class="color-picker-slider-number"
            min="0"
            max="100"
            [ngModel]="displayCmyk.y"
            (ngModelChange)="onCmykChannelChange('y', $event)"
          />
          <span class="color-picker-slider-unit">%</span>
        </div>
        <div class="color-picker-slider-row">
          <span
            class="color-picker-slider-label"
            [matTooltip]="'Key (Black)'"
            matTooltipPosition="above"
            matTooltipClass="design-3d-tooltip"
            >K</span
          >
          <input
            type="range"
            min="0"
            max="100"
            [ngModel]="displayCmyk.k"
            (ngModelChange)="onCmykChannelChange('k', $event)"
          />
          <input
            type="number"
            class="color-picker-slider-number"
            min="0"
            max="100"
            [ngModel]="displayCmyk.k"
            (ngModelChange)="onCmykChannelChange('k', $event)"
          />
          <span class="color-picker-slider-unit">%</span>
        </div>
      </div>
    }

    @if (mode === "rgb") {
      <div class="color-picker-sliders color-picker-sliders--rgb">
        <div class="color-picker-slider-row">
          <span
            class="color-picker-slider-label"
            [matTooltip]="'Red'"
            matTooltipPosition="above"
            matTooltipClass="design-3d-tooltip"
            >R</span
          >
          <input
            type="range"
            min="0"
            max="255"
            [ngModel]="displayRgb.r"
            (ngModelChange)="onRgbChannelChange('r', $event)"
          />
          <input
            type="number"
            class="color-picker-slider-number"
            min="0"
            max="255"
            [ngModel]="displayRgb.r"
            (ngModelChange)="onRgbChannelChange('r', $event)"
          />
        </div>
        <div class="color-picker-slider-row">
          <span
            class="color-picker-slider-label"
            [matTooltip]="'Green'"
            matTooltipPosition="above"
            matTooltipClass="design-3d-tooltip"
            >G</span
          >
          <input
            type="range"
            min="0"
            max="255"
            [ngModel]="displayRgb.g"
            (ngModelChange)="onRgbChannelChange('g', $event)"
          />
          <input
            type="number"
            class="color-picker-slider-number"
            min="0"
            max="255"
            [ngModel]="displayRgb.g"
            (ngModelChange)="onRgbChannelChange('g', $event)"
          />
        </div>
        <div class="color-picker-slider-row">
          <span
            class="color-picker-slider-label"
            [matTooltip]="'Blue'"
            matTooltipPosition="above"
            matTooltipClass="design-3d-tooltip"
            >B</span
          >
          <input
            type="range"
            min="0"
            max="255"
            [ngModel]="displayRgb.b"
            (ngModelChange)="onRgbChannelChange('b', $event)"
          />
          <input
            type="number"
            class="color-picker-slider-number"
            min="0"
            max="255"
            [ngModel]="displayRgb.b"
            (ngModelChange)="onRgbChannelChange('b', $event)"
          />
        </div>
      </div>
    }

    @if (mode === "hex") {
      <div class="color-picker-hex">
        <input type="color" [ngModel]="displayHex" (ngModelChange)="onHexChange($event)" />
        <input type="text" class="color-picker-hex-text" [ngModel]="displayHex" (ngModelChange)="onHexChange($event)" />
      </div>
    }
  </div>
</ng-template>
